export const parseAttributes = (attributes) => {
  return attributes.map(attribute => ({
    ...attribute,
    value: attribute.value ? JSON.parse(attribute.value) : null
  }))
}

export const stringifyAttributes = (attributes) => {
  return attributes.map(attribute => ({
    _id: attribute._id,
    key: attribute.key,
    type: attribute.type,
    value: attribute.value ? JSON.stringify(attribute.value) : null
  }))
}

export const getAttrs = (attributes, options = {}) => {
  if (options.parseAttributes) {
    attributes = parseAttributes(attributes) // eslint-disable-line
  }

  return attributes.reduce((attrs, attribute) => {
    return {
      ...attrs,
      [attribute.key]: attribute.value
    }
  }, {})
}


// WEBPACK FOOTER //
// ./src/utils/index.js